import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { usePartnerMode } from '../hooks/usePartnerMode'

type OrderStartRedirectProps = {
  /** Le composant public à rendre si l'utilisateur n'est pas en mode partenaire */
  publicElement: React.ReactElement
}

/**
 * Guard de route pour /order/start.
 *
 * - Si le mode partenaire est en cours de résolution → placeholder neutre (pas de navigation).
 * - Si l'utilisateur est en mode partenaire → redirige vers /partner/book/service (conserve la querystring).
 * - Sinon → rend le composant public passé en prop.
 */
const OrderStartRedirect: React.FC<OrderStartRedirectProps> = ({ publicElement }) => {
  const { loading, isPartnerMode } = usePartnerMode()
  const location = useLocation()

  if (loading) {
    return null
  }

  if (isPartnerMode) {
    return <Navigate to={`/partner/book/service${location.search}`} replace />
  }

  return publicElement
}

export default OrderStartRedirect
